import { create } from "zustand";

import { ScheduleDataDto } from "@/components/Schedules/types";

interface ScheduleState {
  selectedSchedule: ScheduleDataDto | null;
  setSelectedSchedule: (schedule: ScheduleDataDto | null) => void;
}

export const useScheduleStore = create<ScheduleState>()((set) => ({
  selectedSchedule: null,
  setSelectedSchedule: (schedule) => set({ selectedSchedule: schedule })
}));
